import React, { useEffect, useMemo, useRef } from "react";
import "./PopUp.scss";
import { PopUpCloseIcon } from "../Icons/CommonIcons";
import useKeyPressAction from "../../../src/CustomHooks/useKeyPressAction";

interface PopupProps {
  isOpen: boolean;
  onClose?: (() => void) | any;
  header?: string;
  body?: () => React.ReactNode;
  actionButtons?: React.ReactNode;
  closeButton?: boolean;
  width?: string,
  height?: string;
  bodyClass?: string;
  error?: string;
  onAction?: (() => void) | any,
  ButtonApproveText?: any,
  buttonApproveClass?: string;
  buttonCancelText?: any;
  buttonCancelClass?: string;
  disabledActionButton?: boolean
}

const PopUp: React.FC<PopupProps> = ({ isOpen, onClose, header, body, actionButtons, closeButton = false, width, error = "", height, bodyClass = '', onAction, ButtonApproveText, buttonCancelText, buttonApproveClass, buttonCancelClass, disabledActionButton = false }) => {
  const popupRef = useRef<HTMLDivElement>(null);

  /* if (actionButtons&&onAction) {
    useKeyPressAction('Enter',  onAction);
    useKeyPressAction('Escape', onClose);
  } */

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }




  return (
    <div className="popup">
      <div className="popup-content" ref={popupRef} style={{ width: width, height: height }}>
        <div className="close-header">
          {header && <h5 className="popup-header">{header}</h5>}
          {closeButton && <button className="popup-close" onClick={onClose}>
            <PopUpCloseIcon />
          </button>}
        </div>
        {body && <div className={`popup-body ${bodyClass}`}>{error && <div className="statusError">{error}</div>}{body()}</div>}
        {actionButtons && <div className="popup-actions">
          <div className="di-fl">
            {buttonCancelText && <button className={`${buttonCancelClass || "button-secondary-lightGreen"}`} onClick={onClose}> {buttonCancelText} </button>}
            {ButtonApproveText && <button disabled={disabledActionButton} className={`${buttonApproveClass || "button-primary-light"}`} onClick={onAction} > {ButtonApproveText}</button>}
          </div>
          {/* {actionButtons} */}

        </div>}
      </div>
    </div>
  );
};

export default PopUp;
